// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getSparesCatalog(_, data) {
            const response = await axios.get(`${MAIN_API}/api/sharepart/directory/all`, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
        async createSpare(_, formData) {
            const response = await axios.post(`${MAIN_API}/api/sharepart/directory/create`, formData)
            return response.data
        },
        async addPartnerSpare(_, data) {
            const response = await axios.post(`${MAIN_API}/api/sharepart/partner/create`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getSpareBrands() {
            const response = await axios.get(`${MAIN_API}/api/sharepart/brand`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async addSpareBrand(_, data) {
            const response = await axios.post(`${MAIN_API}/api/sharepart/brand/create`, {}, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
        async deleteSpareBrand(_, id) {
            const response = await axios.delete(`${MAIN_API}/api/sharepart/brand/delete/${id}`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async updateSpareBrand(_, data) {
            const response = await axios.put(`${MAIN_API}/api/sharepart/brand/update/${data.id}`, {}, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
    },
    getters: {
    }
}
